module.exports = __webpack_public_path__ + "static/4-e00390530bc11148d4d4359bf19f8fb8.jpg";